module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner affairEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("栏目管理")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    ref: "tabNavs",
    staticClass: "tabNavs"
  }, [_vm._l((_vm.navs), function(item, index) {
    return _c('div', {
      key: index,
      class: ['tabItem', {
        'act': _vm.navAct === index
      }],
      on: {
        "click": function($event) {
          _vm.tabChange($event, index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item) + "\n                ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "moveLine",
    style: (_vm.lineStr)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 0),
      expression: "navAct===0"
    }],
    ref: "firstTab",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.firstRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "selectGp",
    attrs: {
      "label": "所属栏目"
    }
  }, [_c('el-cascader', {
    ref: "cascaderColumn",
    attrs: {
      "size": "medium",
      "options": _vm.columnTree,
      "show-all-levels": true,
      "props": {
        value: 'id',
        label: 'name',
        children: 'dtos',
        checkStrictly: true
      },
      "value": _vm.ids,
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleColumnChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "栏目名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入栏目全称"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v)
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "栏目图"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "tips": "（115*70推荐）",
      "limit": "1"
    },
    on: {
      "change": _vm.fileChange
    },
    model: {
      value: (_vm.ruleForm.thumbnail),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "thumbnail", $$v)
      },
      expression: "ruleForm.thumbnail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "栏目模板",
      "prop": "modelLink"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.ruleForm.modelLink),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "modelLink", $$v)
      },
      expression: "ruleForm.modelLink"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "500"
    },
    attrs: {
      "label": "内容页模板",
      "prop": "contentLink"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.ruleForm.contentLink),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contentLink", $$v)
      },
      expression: "ruleForm.contentLink"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "目标窗口"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.window),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "window", $$v)
      },
      expression: "ruleForm.window"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("本窗口")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("新窗口")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "500"
    },
    attrs: {
      "label": "自定义链接"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.ruleForm.customLink),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "customLink", $$v)
      },
      expression: "ruleForm.customLink"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "tip"
  }, [_vm._v("当栏目需要指向其他页面，可通过自定义链接实现")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium",
      "controls-position": "right",
      "min": 0
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.ruleForm.weight),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "weight", $$v)
      },
      expression: "ruleForm.weight"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 1),
      expression: "navAct===1"
    }],
    ref: "secondTab",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.secondRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SEO标题",
      "prop": "seoTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.ruleForm.seoTitle),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "seoTitle", $$v)
      },
      expression: "ruleForm.seoTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SEO关键字",
      "prop": "seoKeyword"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.ruleForm.seoKeyword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "seoKeyword", $$v)
      },
      expression: "ruleForm.seoKeyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SEO描述内容",
      "prop": "seoDesc"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "size": "medium",
      "type": "textarea"
    },
    model: {
      value: (_vm.ruleForm.seoDesc),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "seoDesc", $$v)
      },
      expression: "ruleForm.seoDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "size": "medium",
      "type": "textarea"
    },
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goSave()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("返回")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-0b982680"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/column/add/index.vue
// module id = 1410
// module chunks = 1